import { Col, Icon } from 'components';
import { theme } from 'lib';
import styled from 'styled-components';

const CloseContainer = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 24px;
  background-color: ${theme.SECONDARY};
  right: -8px;
  top: -8px;
  position: absolute;
  cursor: pointer;
  z-index: 2;
`;

const RemoveButton = ({ onClick }) => (
  <CloseContainer onClick={onClick}>
    <Col centerAll ht="100%">
      <Icon type="close" dimensions={12} col="#fff" />
    </Col>
  </CloseContainer>
);

export default RemoveButton;
